import { render, staticRenderFns } from "./RequestsTab.vue?vue&type=template&id=7931364f&"
import script from "./RequestsTab.vue?vue&type=script&lang=js&"
export * from "./RequestsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports